import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { IRsvpAdditionalGuest, RsvpStatus } from "@/models"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { RsvpResponse } from "@/models"

export interface CreateRsvpResponseArgs {
  name: string
  email?: string
  additionalGuests?: IRsvpAdditionalGuest[]
  rsvpDetails: {
    rsvpStatus: RsvpStatus
    guestRSVPComment?: string
    dietaryRequirements?: string
    songRequests?: string
    guestCount?: number
  }
}

export interface ICreateRsvpResponseArgsParams {
  eventAlbumId?: number
  accessToken?: string
}

export async function createRsvpResponse(rsvpResponse: CreateRsvpResponseArgs, eventVaultId: number, accessToken?: string, albumId?: number) {
  const payload: CreateRsvpResponseArgs = {
    ...rsvpResponse,
    ...("additionalGuests" in rsvpResponse ? { additionalGuests: rsvpResponse.additionalGuests } : {}),
  }

  const options: AxiosRequestConfig = {}

  const params: ICreateRsvpResponseArgsParams = {
    eventAlbumId: albumId,
    accessToken,
  }

  if (params.eventAlbumId || params.accessToken) {
    options.params = params
  }

  const response = await v1.post(`/events/${eventVaultId}/rsvp`, payload, options)

  return RsvpResponse.fromResponse(response.data.data)
}

export const CREATE_RSVP_RESPONSE = "createRsvpResponse"

export function useSendRsvpResponse(eventVaultId?: MaybeRef<number | undefined>, accessToken?: MaybeRef<string | undefined>, albumId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: [CREATE_RSVP_RESPONSE, eventVaultId, accessToken, albumId],
    mutationFn: (rsvpResponse: CreateRsvpResponseArgs) => createRsvpResponse(rsvpResponse, toValue(eventVaultId)!, toValue(accessToken), toValue(albumId)),
  })
}
